import { LocalOperation } from 'hooks/store/types';
import { useDispatch } from 'hooks/utils';
import { groupFormElements, GroupFormElementsAction } from 'store/data/forms';
import { ActionPayload } from 'store/types';

export function useGroupFormElements(): LocalOperation<
	(payload: ActionPayload<GroupFormElementsAction>) => void
> {
	const dispatch = useDispatch();

	function handler(payload: ActionPayload<GroupFormElementsAction>) {
		dispatch(groupFormElements(payload));
	}

	return handler;
}
